import { CateringTranslations } from "./catering-pt-br";

export const CATERING_FR_FR: CateringTranslations = {
	title: "Catering",
	description:
		"Gérez le catering de vos événements, recevez des propositions, envoyez des devis et suivez le tout au même endroit.",
};
